// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { RootState } from '../../app/store';

// selectors.ts
const selectLoading = (state: RootState) => state.applicationState.isLoading;
const selectPreviousForm = (state: RootState) => state.applicationState.previousState;

export {selectLoading, selectPreviousForm};
